import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useEmbedParams = () => {
  const location = useLocation();
  
  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    
    return {
      isEmbedded: params.get('embedded') === 'true',
      theme: params.get('theme') || 'light',
      
      // My Learning settings - check if parameter is '0' to hide
      hideMlTypeFilter: params.get('ml_type_filter') === '0',
      hideMlSortingFilter: params.get('ml_sorting_filter') === '0',
      hideMlGridList: params.get('ml_grid_list') === '0',
      
      // Catalog settings - check if parameter is '0' to hide
      hideCatTypeFilter: params.get('cat_type_filter') === '0',
      hideCatSortingFilter: params.get('cat_sorting_filter') === '0',
      hideCatGridList: params.get('cat_grid_list') === '0'
    };
  }, [location.search]);
};